<template>
  <div id="header" class="main-header">
    <div class="other">
      <span class="charger">
        <router-link to="/user/userinfo">{{userInfo.name}}</router-link>
      </span>
      <div class="exit" @click="logout"></div>
    </div>
  </div>
</template>

<script>
  import { apiLogout } from '../../api/user'

  export default {
    name: 'main-header',
    data() {
      return {}
    },
    created() {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (!this.userInfo) {
        this.$router.push({ name: 'login' })
      }
    },
    computed: {
    },
    methods: {
      logout() {
        apiLogout()
        window.sessionStorage.clear()
        this.$router.push({ name: 'login' })
      }
    }
  }
</script>

<style lang="stylus">
  .main-header
    background #fff
    text-align right
    font-size 14px
    .other
      padding 0 50px
      height 60px
      display flex
      justify-content flex-end
      align-items center
      .charger
        user-select none
        padding 1px 20px 0 0
        border-right 1px solid #424853
        cursor pointer
      .exit
        display inline-block
        margin-left 13px
        width 20px
        height 20px
        background url("../../assets/images/exit.png") no-repeat center
        background-size 20px
        cursor pointer
</style>
